import React from 'react';
//import { GridBoxTitle } from "../StoreHomePage/BannersGrid/styled";
import MoreCategoriesSection from './MoreCategoriesSection';
// import MoreCategoryGrid from "./MoreCategoryGrid";

export default function MoreCategoriesCover(props) {
  const { subCategoriesData, categoryNavBarData, bottomRef } = props;
  return (
    <>
      {subCategoriesData?.[0]?.subCategories?.length ? (
        <>
          {/* <MoreCategoryTitle browse>
                        Browse Related categories
                    </MoreCategoryTitle> */}
          <MoreCategoriesSection
            bottomRef={bottomRef}
            subCategoriesData={subCategoriesData}
          />
        </>
      ) : null}
      {/* <DesktopHide>
                <MoreCategoryTitle>SHOP FOR</MoreCategoryTitle>
                <MoreCategoryGrid data={categoryNavBarData} />
            </DesktopHide> */}
    </>
  );
}
